import { GetVenueOperatorType as ApiVenueOperatorType } from 'src/api/generated/touring/types';
import { mapAddress, mapContact, mapLinkableEntityType } from '../../../common';
import { VenueOperatorType } from '../../types';
import { mapVenueOperatorContactPerson } from '../mapVenueOperatorContactPerson';

export const mapVenueOperator = (
  apiVenueOperator: ApiVenueOperatorType
): VenueOperatorType => {
  return {
    company: mapLinkableEntityType(apiVenueOperator.company),
    address: mapAddress(apiVenueOperator.address),
    contact: mapContact(apiVenueOperator.contact),
    contactPersons: apiVenueOperator.contactPersons.map(
      mapVenueOperatorContactPerson
    ),
  };
};
